/* eslint-disable test-selectors/onChange */
import React, { memo, useMemo } from 'react';

import classnames from 'classnames';
import Dropdown from 'react-dropdown';
import MediaQuery from 'react-responsive';

import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { device } from 'helpers/screenSizes';
import { sortBalancesBySortPriority } from 'helpers/utils';
import { ArrowDownThin, ArrowUpThinActive } from 'styles/assets/icons';
import { IUserKernel } from 'types/IUser';

import styles from '../trasnferFundModal.module.scss';

interface IUserOption {
  id: number;
  account_name: string;
}

interface IAccountBalance {
  asset_symbol: string;
  available_balance: number;
  precision: number;
}

interface IAccountOptionsProps {
  subAccounts: IUserKernel[];
  onChange: (option: any) => {};
  value?: string | null;
  keySlug: string;
  selectedAccount: IUserOption;
  mainAccount: IUserOption;
}
export interface ITransferFundModalState {
  sourceAccount?: null | IUserOption;
  destinationAccount?: IUserOption | null;
  selectedCoin?: string;
  amount: string;
  sourceAccountBalanceObj?: IAccountBalance;
  openSourceAccountOptions: boolean;
  openDestinationAccountOptions: boolean;
  openCoinList: boolean;
}
export interface ITransferFundModalError {
  sourceAccountError?: null | string;
  destinationAccountError?: null | string;
  selectedCoinError?: null | string;
  amountError?: null | string;
  responseError?: null | string;
}
interface IWithdrawalOptionListProps {
  enabledWallets: object[];
  onChange: ({ value }: { value: string }) => void;
  value: string;
}
const initState: ITransferFundModalState = {
  amount: '',
  openSourceAccountOptions: false,
  openDestinationAccountOptions: false,
  openCoinList: false,
};
const initError: ITransferFundModalError = {};

const AccountOptions = ({
  subAccounts,
  onChange,
  value,
  keySlug,
  selectedAccount,
  mainAccount,
}: IAccountOptionsProps) => {
  const accounts = [mainAccount, ...subAccounts].filter(
    obj => obj?.id !== selectedAccount?.id
  );

  const options = accounts.map(account => {
    return {
      label: (
        <span
          key={`${keySlug}-${account.id}`}
          className="option"
          data-symbol={account.id}
          data-palette="options">
          {account.account_name}
        </span>
      ),
      value: `${account.account_name}`,
      id: account.id,
    };
  });
  return (<>
    <MediaQuery query={device.up.md}>
      <div className={styles[`account-selection`]}>
        <Dropdown
          options={options}
          onChange={onChange}
          value={value}
          placeholderClassName={styles[`account-placeholder`]}
          menuClassName={`${styles[`account-dropdown-menu`]}`}
          controlClassName={styles[`account-control-area`]}
          arrowClosed={<ArrowDownThin />}
          arrowOpen={<ArrowUpThinActive />}
          placeholder=""
        />
      </div>
    </MediaQuery>
    <MediaQuery query={device.down.md}>
      <div className="modal-body">
        {options.map(option => {
          return (
            (<span
              data-testid="hEDRHc8eXnpr2HD2wIzHK"
              aria-hidden="true"
              key={`coin-${option.value}`}
              className={classnames('coin-symbol', {
                active: option.value === value,
              })}
              onClick={() => onChange(option)}
              data-palette="AccountOptions">
              {option.value}
            </span>)
          );
        })}
      </div>
    </MediaQuery>
  </>);
};

const WithdrawalOptionList = memo(
  ({ enabledWallets, onChange, value }: IWithdrawalOptionListProps) => {
    const walletOptions = useMemo(() => {
      return sortBalancesBySortPriority(enabledWallets);
    }, [enabledWallets]);

    return (<>
      <MediaQuery query={device.up.md}>
        {walletOptions.map(option => {
          return (
            (<span
              data-testid="nK2XKV8jTanb6GrXdkKej"
              aria-hidden="true"
              onClick={() => {
                onChange({ value: option.asset.symbol });
              }}
              className={classnames(styles['coin-option'], {
                [`${styles['active-coin-option']}`]: value === option.asset.symbol,
                [styles['coin-optionIndianExchange']]: IS_INDIAN_EXCHANGE,
              })}
              data-symbol={option.asset.symbol}
              data-palette="WithdrawalOptionList">
              {option.asset.symbol}
            </span>)
          );
        })}
      </MediaQuery>
      <MediaQuery query={device.down.md}>
        <div className="modal-body">
          {walletOptions.map(option => {
            return (
              (<span
                data-testid="7qvrXqu6rpNmVQw1Bsemw"
                aria-hidden="true"
                key={option.asset.symbol}
                className={classnames('coin-symbol', {
                  active: option.asset.symbol === value,
                })}
                onClick={() => onChange({ value: option.asset.symbol })}
                data-palette="WithdrawalOptionList">
                {option.asset.symbol}
              </span>)
            );
          })}
        </div>
      </MediaQuery>
    </>);
  }
);

export { initState, AccountOptions, WithdrawalOptionList, initError };
